<div
  *ngIf="
    item.displayType !== DisplayType.ORDER_CANCELLED ||
    item.orderHeader?.orderType !== 'VS'
  "
  class="action-link-group"
>
  <ng-container
    *ngFor="let actionLink of actionLinks.orderLinks; let i = index"
  >
    <ng-container *ngIf="actionLink.displayFlag; else noDisplayFlag">
      <ng-container *appShowSplit="[actionLink.displayFlag]">
        <a
          *ngIf="actionLink.displayLink"
          class="action-link"
          [class.insights-action-link]="
            actionLink.dataCy === 'insights-order-link'
          "
          [class.red-text]="
            actionLink.dataCy === 'resubmit-submission-error-link'
          "
          [attr.data-cy]="actionLink.dataCy"
          (click)="actionLink.linkAction($event)"
          ><span>{{ actionLink.title | translate }}</span>
          <ion-badge
            *ngIf="
              actionLink.dataCy === 'insights-order-link' && actionLink.badge
            "
            class="insights-badge"
            data-cy="insights-count-badge"
          >
            {{ actionLink.badge }}
          </ion-badge>
        </a>
        <div *ngIf="displayBar">
          <span
            *ngIf="
              i < actionLinks.orderLinks.length - 1 &&
              actionLink.displayLink &&
              actionLinks.orderLinks[i + 1]?.displayLink
            "
            class="link-separator"
          >
            &nbsp; | &nbsp;</span
          >
        </div>
      </ng-container>
    </ng-container>
    <ng-template #noDisplayFlag>
      <a
        *ngIf="actionLink.displayLink"
        class="action-link"
        [attr.data-cy]="actionLink.dataCy"
        (click)="actionLink.linkAction($event)"
        ><span>{{ actionLink.title | translate }}</span>
      </a>
      <span
        *ngIf="
          displayBar &&
          i < actionLinks.orderLinks.length - 1 &&
          actionLink.displayLink &&
          actionLinks.orderLinks[i + 1]?.displayLink
        "
        class="link-separator"
        >&nbsp; | &nbsp;</span
      >
    </ng-template>
  </ng-container>
</div>
